module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1100.6b90bab7.png";